








import { Component, Vue, Watch } from 'vue-property-decorator';
import NotificationToast from '@/components/ui/NotificationToast.vue';
import SegmentAnalyticsPlugin from './plugins/segment';
import router from './router';
import { UserGuidingInstance } from './plugins/user-guiding';

Vue.use(SegmentAnalyticsPlugin, {
  segmentId: process.env.VUE_APP_SEGMENT_ID,
  router: router
});

Vue.use(UserGuidingInstance, {
  userGuidingId: process.env.VUE_APP_USER_GUIDING_ID
});

@Component({
  components: {
    NotificationToast
  }
})
export default class App extends Vue {
  @Watch('$route')
  async handler(to: any, _from: any) {
    return (document.title = to.meta.title || 'ClearGlass');
  }
}
